import { numConvert, calculation } from "@/method";
import moment from "moment";

export default function compute(data, date) {
    const listName = [
        'Jan_ADR',
        'Feb_ADR',
        'Mar_ADR',
        'Apr_ADR',
        'May_ADR',
        'Jun_ADR',
        'Jul_ADR',
        'Aug_ADR',
        'Sep_ADR',
        'Oct_ADR',
        'Nov_ADR',
        'Dec_ADR',
    ];

    // YTD RN REV
    data.forEach((item, i) => {
        data[i].YTD_Room_Nts = listName.reduce((a, b, i) => {
            if (moment().format('M') > (i + 1)) {
                a += numConvert(item[b.split('_')[0] + '_Room_Nts']);
            }
            return a;
        }, 0).toFixed(2);
        data[i].YTD_Revenue = listName.reduce((a, b, i) => {
            if (moment().format('M') > (i + 1)) {
                a += numConvert(item[b.split('_')[0] + '_Revenue']);
            }
            return a;
        }, 0).toFixed(2);
    });

    [...listName, 'YTD_ADR'].forEach(name => {
        const RN = name.split('_')[0] + '_Room_Nts';
        const REV = name.split('_')[0] + '_Revenue';
        data.forEach((item, i) => {
            data[i][name] = calculation(
                data[i][REV],
                data[i][RN],
            );
        });
    });
    return data
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-5/compute.js